export default {"src":"/_next/static/media/Right.d84a96fd.svg","height":54,"width":30,"blurWidth":0,"blurHeight":0};